import { Flexbox } from '@morressier/ts';
import { FC } from 'react';
import { FaTag } from 'react-icons/fa';
import * as ContainerStyles from '../styles';
import * as Styles from './styles';

const Tags: FC<{
  event:
    | (Partial<MorressierEvent> & {
        tabsConfig?: MorressierEventTabsConfiguration;
      })
    | undefined;
  session: MorressierSession;
}> = props => {
  const { session } = props;
  return session.type !== 'NETWORKING' && !!session.labels?.length ? (
    <div>
      <ContainerStyles.SubTitle>Tags</ContainerStyles.SubTitle>
      <Flexbox flexWrap="wrap" gap="1rem">
        {session.labels?.map(label => (
          <Styles.SessionTag key={label.key}>
            <FaTag style={{ marginRight: '0.5rem' }} />
            {label.label}
          </Styles.SessionTag>
        ))}
      </Flexbox>
    </div>
  ) : null;
};

export default Tags;
